export const skills = [
  'Python',
  'PyTorch',
  'Computer Vision',
  'ROS',
  'TypeScript',
  'React',
  'Go',
  'AWS',
  'Docker',
  'Kubernetes',
  'C/C++',
  'Embedded Systems',
];
